import { render, staticRenderFns } from "./ABSummary.vue?vue&type=template&id=5e0c4e18&scoped=true"
import script from "./ABSummary.vue?vue&type=script&lang=js"
export * from "./ABSummary.vue?vue&type=script&lang=js"
import style0 from "./ABSummary.vue?vue&type=style&index=0&id=5e0c4e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c4e18",
  null
  
)

export default component.exports